import { env } from '@/config/env';

/**
 * Generate login URL for Moneta authentication
 */
export const generateLoginUrl = (): string => {
  const params = new URLSearchParams({
    client_id: env.VITE_AUTH_CLIENT_ID,
    client_redirect_url: env.VITE_AUTH_REDIRECT_URL,
    // signin_option: 'password',
  });

  return `${env.VITE_AUTH_BASE_URL}/users/login?${params.toString()}`;
};

/**
 * Redirect to login page
 */
export const redirectToLogin = (): void => {
  const loginUrl = generateLoginUrl();
  window.location.href = loginUrl;
};
